import { api } from '@/api/client'
import type { components } from '@/api/types.gen'

export type Manufacturer = components['schemas']['Manufacturer']
export type Supplier = components['schemas']['Supplier']
export type MeasurementUnit = components['schemas']['MeasurementUnit']
export type Currency = components['schemas']['Currency']

export const manufacturersKey = ['manufacturers'] as const
export const suppliersKey = ['suppliers'] as const
export const unitsKey = ['units'] as const
export const currenciesKey = ['currencies'] as const

export async function fetchManufacturers(): Promise<Manufacturer[]> {
  const { data } = await api.GET('/api/manufacturers')
  return data ?? []
}

export async function fetchSuppliers(): Promise<Supplier[]> {
  const { data } = await api.GET('/api/suppliers')
  return data ?? []
}

export async function fetchUnits(): Promise<MeasurementUnit[]> {
  const { data } = await api.GET('/api/units')
  return data ?? []
}

export async function fetchCurrencies(): Promise<Currency[]> {
  const { data } = await api.GET('/api/currencies')
  return data ?? []
}
